export default function Circle({y, x}) {
    return (
        <div className={`absolute -z-50 ${y} ${x} w-[1400px] h-[1400px] rounded-full bg-circle overflow-hidden`}>
            &nbsp;
        </div>
    );
}